module.exports = __webpack_public_path__ + "static/assets/d1f32534bcbcaf9151851be9a1c58fc1.svg";